module.exports = __webpack_public_path__ + "static/media/DistractionTechniquesENG.d5eba562.vtt";